import convertKeys from 'convert-keys';

export const camelize = value => {
  if (value?.type === 'application/zip') {
    return value;
  }

  return convertKeys.toCamel(value);
};

export const snake = value => {
  return convertKeys.toSnake(value);
};
